/* ResponsiveTabs.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["showAetherAppListingPage"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _37 = "._1e0c116y{display:inline-flex}";
const _36 = "._18u01eps{margin-left:var(--ds-space-100)}";
const _35 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _34 = "._1pbycs5v{z-index:2}";
const _33 = "._1xi2idpf{right:0}";
const _32 = "._kqswstnw{position:absolute}";
const _31 = "._lcxvglyw{pointer-events:none}";
const _30 = "._1bsb8pqr{width:2.5rem}";
const _29 = "._4t3i8pqr{height:2.5rem}";
const _28 = "._11q71915{background:-webkit-linear-gradient(0deg,var(--_ux5vp5),var(--ds-background-input))}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { getTokenValue } from '@atlaskit/tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _27 = "@media not all and (min-width:48rem){._5f8cidpf>div>[role=tab]:not(:last-of-type){margin-right:0}}";
const _26 = "@media not all and (min-width:48rem){._5f8cxjmg>div>[role=tab]:not(:last-of-type){margin-right:var(--ds-space-200)}}";
const _25 = "._eonridpf>div>[role=tab]:not(:last-of-type){margin-right:0}";
const _24 = "._eonrhiv4>div>[role=tab]:not(:last-of-type){margin-right:var(--ds-space-400)}";
const _23 = "@media (min-width:64rem){._ibqnidpf>div>[role=tab]:first-of-type{margin-left:0}}";
const _22 = "@media (min-width:64rem){._ibqn1eps>div>[role=tab]:first-of-type{margin-left:var(--ds-space-100)}}";
const _21 = "@media (min-width:90rem){._1jru1fhj>div>[role=tab]{padding:var(--ds-space-100) var(--ds-space-200)}}";
const _20 = "@media (min-width:90rem){._1jru1akh>div>[role=tab]{padding:var(--ds-space-050) var(--ds-space-100)}}";
const _19 = "._121zi7a9>div>[role=tab]{font-weight:var(--ds-font-weight-regular,400)}";
const _18 = "._121z1pd9>div>[role=tab]{font-weight:var(--ds-font-weight-semibold,600)}";
const _17 = "._j67z1wug>div>[role=tab]{height:auto}";
const _16 = "._j67zyn4p>div>[role=tab]{height:2.75rem}";
const _15 = "._rwqn1inc>div>[role=tab]{padding:var(--ds-space-075) var(--ds-space-150)}";
const _14 = "._rwqn1akh>div>[role=tab]{padding:var(--ds-space-050) var(--ds-space-100)}";
const _13 = "._tr9oo1fv>div>[role=tab]{line-height:1.8rem}";
const _12 = "._tr9o1k92>div>[role=tab]{line-height:1.25rem}";
const _11 = "@media (min-width:90rem){}";
const _10 = "@media not all and (min-width:48rem){}";
const _9 = "@media (min-width:64rem){}";
const _8 = "._vz1a1h6o>div>[role=tab]{align-items:center}";
const _7 = "._ux2c1txw>div>[role=tab]{display:flex}";
const _6 = "._xvmwljao>div>[role=tab]{font-size:var(--ds-font-size-200,1rem)}";
const _5 = "._1f6t1ns9>div>[role=tab]{min-width:-moz-fit-content;min-width:fit-content}";
const _4 = "._15peidpf::-webkit-scrollbar{height:0}";
const _3 = "._1fjgglyw{scrollbar-width:none}";
const _2 = "._8am5i4x0{-webkit-overflow-scrolling:touch}";
const _ = "._1reo1wug{overflow-x:auto}";
export const TabListContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      showAetherAppListingPage
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo1wug _8am5i4x0 _1fjgglyw _15peidpf _1f6t1ns9 _xvmwljao _ux2c1txw _vz1a1h6o", __cmplp.showAetherAppListingPage ? "_tr9o1k92" : "_tr9oo1fv", __cmplp.showAetherAppListingPage ? "_rwqn1akh" : "_rwqn1inc", __cmplp.showAetherAppListingPage ? "_j67zyn4p" : "_j67z1wug", __cmplp.showAetherAppListingPage ? "_121z1pd9" : "_121zi7a9", __cmplp.showAetherAppListingPage ? "_1jru1akh" : "_1jru1fhj", __cmplp.showAetherAppListingPage ? "_ibqn1eps" : "_ibqnidpf", __cmplp.showAetherAppListingPage ? "_eonrhiv4" : "_eonridpf", __cmplp.showAetherAppListingPage ? "_5f8cxjmg" : "_5f8cidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabListContainer.displayName = 'TabListContainer';
}
export const HorizontalScrollShadow = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_28, _29, _30, _31, _32, _33, _34, _35]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_ux5vp5": ix(getTokenValue('color.background.input') + 40)
      }),
      ref: __cmplr,
      className: ax(["_11q71915 _4t3i8pqr _1bsb8pqr _lcxvglyw _kqswstnw _1xi2idpf _1pbycs5v _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HorizontalScrollShadow.displayName = 'HorizontalScrollShadow';
}
export const StyledLozenge = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_36, _37]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u01eps _1e0c116y", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledLozenge.displayName = 'StyledLozenge';
}